<template>
  <div>
    <!-- <span v-text="question"></span> -->
    <!-- <PageTitle> {{ nav[active[0]].name }}</PageTitle>
    <div class="page-card questiongroup">
      <h2 class="mb-2 page-title pl-2">{{ open ? 'Optional' : copy.intro }}</h2>
      <form v-if="!open" id="group" @change="updateScore()">
        <Question
          v-for="(question, ind) in copy.questions"
          :key="ind"
          :qid="ind"
          :group="group"
          :question="`${group}Q${ind}`"
          class="px-2 py-4"
        >
          {{ ind + 1 }}: {{ question }}
        </Question>
        <div v-if="!open" class="text-xs text-center mt-8">
          <span class="px-3"><b>1</b>-&nbsp;Poor or N/A to my business</span>
          <span class="px-3"><b>2</b>-&nbsp;Below average</span>
          <span class="px-3"><b>3</b>-&nbsp;Average</span>
          <span class="px-3"><b>4</b>-&nbsp;Above average</span>
          <span class="px-3"><b>5</b>-&nbsp;Excellent</span>
        </div>
      </form>
      <OpenQuestion v-if="open" :question="copy.openquestions[0]" :group="group">
        {{ copy.openquestions[0] }}
      </OpenQuestion>
    </div>
    <BottomNav
      :key="group + 'nav'"
      :group="group"
      :time="time"
      :open="open"
    /> -->
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import store from '../store';

export default {
  components: {
    Question: () => import('./Question.vue'),
    OpenQuestion: () => import('./OpenQuestion.vue'),
    PageTitle: () => import('./PageTitle.vue'),
    BottomNav: () => import('./BottomNav.vue'),
    // QNav: () => import('./QNav.vue'),
  },
  props: {
    // passinggrade: Number,
    // group: String,
    // copy: Object,
    // open: Boolean,
    question: Object,
    // questionNumber: Number,
  },
  setup(props) {
    // const active = store.getters.getActiveSection;
    // const nav = store.getters.getnav;
    // const scores = store.getters.getscores;
    // const answered = store.getters.getAnswered;
    // const time = ref(Date.now());
    //   const answeredQs = Object.values(scores[props.group]).filter((a) => a > 0);
    //   if (
    //     answeredQs.length === props.copy.questions.length
    //   ) {
    //     return true;
    //   }
    //   return false;
    // );

    function updateScore() {
      time.value = Date.now();
      store.dispatch('updateScoring', {
        group: props.group,
        passinggrade: props.passinggrade,
        scores,
      });
    }

    return {
      // active,
      // updateScore,
      // nav,
      // answered,
      // time,
      question,
    };
  },
};
</script>

<style>
.button {
  background: none;
  border: 2px white solid;
}
</style>
